import { render, staticRenderFns } from "./ApprovedOffer.vue?vue&type=template&id=6d2be128&scoped=true&"
import script from "./ApprovedOffer.vue?vue&type=script&lang=js&"
export * from "./ApprovedOffer.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedOffer.vue?vue&type=style&index=0&id=6d2be128&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2be128",
  null
  
)

export default component.exports